module.exports = __webpack_public_path__ + "img/hamburger.86595150.svg";